import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import userStore from 'entities/user/module/user-store'

import { CASHBACK_VALUE } from 'shared/constants'
import { priceShow } from 'shared/lib/priceShow'
import { ImageLazy } from 'shared/ui/image-lazy'

import { MBonusIcons } from '../mbonus/mbonus-icons'
import { MplusIcon } from '../mbonus/mplus-icon'
import { StatusBought } from '../status-bought'

import { Props } from './model'
import s from './styles.module.scss'

export const CardSmallImage: FC<Props> = ({
  title,
  image,
  price,
  onClick,
  errorImage,
  isPromo,
  detail,
  statusOrder,
  isMbonus,
  oldPrice,
  newPrice,
  isShowingMplus,
}) => {
  const { t } = useTranslation()

  const isShowUserMplus = userStore?.account?.is_mplus_available
  return (
    <div
      className={s.card}
      onClick={onClick}
    >
      <ImageLazy
        src={image}
        alt={title}
        className={s.image}
        errorImage={errorImage}
      />
      <div className={s.info}>
        <div className={s.top}>
          <h4 className={clsx(s.title, 'medium-14')}>{title}</h4>
          <p className={clsx(s.description, 'regular-12')}>{detail}</p>
        </div>

        <div className={s.bottom}>
          <div className={s.prices}>
            <p className={clsx(s.price, 'bold-16')}>
              {priceShow(price)} &#8384;
            </p>

            {oldPrice && newPrice && isPromo && (
              <p className={clsx(s.oldPrice, 'regular-12')}>
                {priceShow(oldPrice)} &#8384;
              </p>
            )}
          </div>

          <div className={s.icons}>
            {isShowingMplus && isShowUserMplus && <MplusIcon />}

            {isMbonus && <MBonusIcons text={`${CASHBACK_VALUE}%`} />}
          </div>

          <StatusBought
            isExcursion
            status={statusOrder}
          />
        </div>
      </div>

      {isPromo && (
        <div className={s.tag}>
          <span className={clsx(s.tagName, 'medium-12')}>
            {t('tickets_page.promo')}
          </span>
        </div>
      )}
    </div>
  )
}
